<template>
  <div>

    <v-layout row wrap v-if="$can('view', 'cases-details')">
      <v-flex md12>
        <h2>Case Description</h2>
        <v-card tile>
          <div
            v-if="caseData && caseData.id"
          >
            <v-layout v-if="$can('view', 'cases-detail-case-description-tab')" id="case-description-tab" row wrap>
              <v-flex md12>
                <v-card tile>
                  <CaseUserCreatedDataTable :caseid="caseData.id" :caseModel="caseData" />
                  <v-divider></v-divider>
                  <CaseCrewDataTable :case="caseData" :caseid="caseData.id" />
                  <v-divider></v-divider>
                  <CasePlanDataTable v-if="caseData.plans_id > 0" :caseData="caseData" :plansid="caseData.plans_id" :casesid="id" @updatePaymentMethod="updatePaymentMethod" @updatePaymentInfo="updatePaymentInfo" />
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout v-if="$can('view', 'vendor')" id="case-description-tab" row wrap>
              <v-flex md12>
                <v-card tile>

                  <v-list>
                    <v-list-tile ripple v-if="formAnswer">
                      <v-flex xs4 md2>
                        <h5><b>Location of Wake</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span>
                          {{ formAnswer.form_answers.main_form.deceased_location_of_wake }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile ripple>
                      <v-flex xs4 md2>
                        <h5><b>Wake Start Date</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span v-if="caseData.is_preplan">
                          N/A (preplan)
                        </span>
                        <span v-else>
                          {{ moment(caseData.wake_start).format('YYYY-MM-DD') }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile ripple>
                      <v-flex xs4 md2>
                        <h5><b>Wake End Date</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span v-if="caseData.is_preplan">
                          N/A (preplan)
                        </span>
                        <span v-else>
                          {{ moment(caseData.wake_end).format('YYYY-MM-DD') }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile ripple>
                      <v-flex xs4 md2>
                        <h5><b>Sending Time</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span v-if="caseData.is_preplan">
                          N/A (preplan)
                        </span>
                        <span v-else>
                          {{ caseData.wake_sending_time ? caseData.wake_sending_time : '-' }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile ripple>
                      <v-flex xs4 md2>
                        <h5><b>Leave Office Time</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span v-if="caseData.is_preplan">
                          N/A (preplan)
                        </span>
                        <span v-else>
                          {{ caseData.leave_office_time ? caseData.leave_office_time : '-' }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile ripple>
                      <v-flex xs4 md2>
                        <h5><b>Leave Wake Time</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span v-if="caseData.is_preplan">
                          N/A (preplan)
                        </span>
                        <span v-else>
                          {{ caseData.leave_wake_time ? caseData.leave_wake_time : '-' }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                    <v-list-tile ripple>
                      <v-flex xs4 md2>
                        <h5><b>Cremation / Burial Time</b></h5>
                      </v-flex>
                      <v-flex xs9 md10>
                        <span v-if="caseData.is_preplan">
                          N/A (preplan)
                        </span>
                        <span v-else>
                          {{ caseData.leave_funeral_time ? caseData.leave_funeral_time : '-' }}
                        </span>
                      </v-flex>
                    </v-list-tile>
                  </v-list>

                </v-card>
              </v-flex>
            </v-layout>
          </div>

        </v-card>
      </v-flex>
    </v-layout>

    <br>

    <v-layout row wrap v-if="$can('view', 'cases-manager-details')">
      <v-flex md12>
        <h2>Case Manager</h2>
        <v-card tile>
          <v-tabs
            show-arrows
            v-if="caseData && caseData.id"
            v-model="selectedTab1"
          >
            <v-tab v-if="$can('view', 'cases-detail-plan-tab')" href="#plan-tab">
              Package
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-client-tab')" href="#client-tab">
              Client
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-services-tab')" href="#services-tab">
              Vendors
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-embalming-tab')" href="#embalming-tab">
              Embalming
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-agreement-feedback-tab')" href="#agreement-feedback-tab">
              Customer Feedback
            </v-tab>
            <v-tab-item v-if="$can('view', 'cases-detail-plan-tab')" id="plan-tab">
              <SelectPlanAndVendors :caseData="caseData" :case-id="caseData.id" editable />
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-client-tab')" id="client-tab">
              <CaseClientDataTable :caseModel="caseData" />
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-services-tab')" id="services-tab">
              <v-card>
                <v-card-text>
                  <CaseServicesDataTable :casesid="caseData.id" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-embalming-tab')" id="embalming-tab">
              <v-card>
                <v-card-text>
                  <v-flex xs6>
                    <h3>
                      Photo
                    </h3>
                    <v-img aspect-ratio="1" v-if="caseData.embalmers_photo" :src="caseData.embalmers_photo"></v-img>
                  </v-flex>
                  <v-flex xs6>
                    <h3>
                      Remarks
                    </h3>
                    {{ caseData.embalmers_remarks }}
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-agreement-feedback-tab')" id="agreement-feedback-tab">
              <CaseAgreementFeedback :caseModel="caseData" :selectedTab1="selectedTab1" />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

    <br>

    <v-layout row wrap>
      <v-flex md12>
        <h2>Finance/Admin</h2>
        <v-card tile>
          <v-tabs
            show-arrows
            v-if="caseData && caseData.id"
            v-model="selectedTab2"
          >
            <v-tab v-if="$can('view', 'cases-detail-pdf-tab')" href="#pdf-tab">
              Vendor Invoices
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-actions-log-tab')" href="#actions-log-tab">
              Actions Log
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-deposits-tab')" href="#deposits-tab">
              Deposit
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-commissions-tab')" href="#commissions-tab">
              Commissions
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-chat-tab')" href="#chat-tab">
              Chat
            </v-tab>
            <v-tab v-if="$can('view', 'cases-detail-readjustment-tab')" href="#readjustment-tab">
              Readjustment
            </v-tab>
            <v-tab-item id="pdf-tab" v-if="$can('view', 'cases-detail-pdf-tab')">
              <v-card v-if="$can('view', 'cases-detail-invoices')">
                <v-card-text>
                  <CaseInvoicesDataTable :casesid="caseData.id" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-actions-log-tab')" id="actions-log-tab">
              <v-card>
                <v-card-text>
                  <CaseActionsLogDataTable :casesid="caseData.id" is-personal />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-deposits-tab')" id="deposits-tab">
              <CaseDeposit :caseModel="caseData" />
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-commissions-tab')" id="commissions-tab">
              <CaseCommissions :caseModel="caseData" />
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-chat-tab')" id="chat-tab">
              <v-card>
                <v-card-text>
                  <CaseFormsChat :casesid="caseData.id" />
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="$can('view', 'cases-detail-readjustment-tab')" id="readjustment-tab">
              <CaseReadjustment :caseModel="caseData" />
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>

  </div>
</template>

<script>
  import CaseUserCreatedDataTable from '@/components/datatables/CaseUserCreatedDataTable'
  import CaseCrewDataTable from '@/components/datatables/CaseCrewDataTable'
  import CaseClientDataTable from '@/components/datatables/CaseClientDataTable'
  import CasePlanDataTable from '@/components/datatables/CasePlanDataTable'
  import CaseServicesDataTable from '@/components/datatables/CaseServicesDataTable'
  import CaseActionsLogDataTable from '@/components/datatables/CaseActionsLogDataTable'
  import CaseInventoriesDataTable from '@/components/datatables/CaseInventoriesDataTable'
  import CaseInvoicesDataTable from '@/components/datatables/CaseInvoicesDataTable'
  import CaseFormsAnswersDataTable from '@/components/datatables/CaseFormsAnswersDataTable'
  import CaseFormsChat from '@/components/CaseFormsChat'
  import CaseFormsCheckList from '@/components/CaseFormsCheckList'
  import SelectPlanAndVendors from '@/components/SelectPlanAndVendors'
  import CaseAgreementFeedback from '@/components/CaseAgreementFeedback'
  import CaseDeposit from '@/components/CaseDeposit'
  import CaseReadjustment from '@/components/CaseReadjustment'
  import CaseCommissions from '@/components/CaseCommissions'
  // import CasePlanAndServicesEdition from '@/components/CasePlanAndServicesEdition'
  // import { mapGetters } from 'vuex'
  // import _ from 'lodash'

  export default {
    components: {
      CaseUserCreatedDataTable,
      CaseCrewDataTable,
      CaseClientDataTable,
      CasePlanDataTable,
      CaseServicesDataTable,
      CaseActionsLogDataTable,
      CaseInventoriesDataTable,
      CaseFormsChat,
      CaseInvoicesDataTable,
      CaseFormsAnswersDataTable,
      SelectPlanAndVendors,
      CaseFormsCheckList,
      CaseAgreementFeedback,
      CaseDeposit,
      CaseReadjustment,
      CaseCommissions
    },
    props: {
      id: {
        // type: String,
        required: true
      },
      goToCheckListsTab: {
        type: Boolean,
        default: false,
        required: false
      },
      goToInvoicesTab: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        caseData: null,
        selectedTab: 0,
        selectedTab1: 1,
        selectedTab2: 0,
        formAnswer: null
      }
    },
    computed: {
      // ...mapGetters(['getCaseById', 'getAllCases']),
      caseDataLoaded () {
        return !!(this.caseData && this.caseData.id > 0)
      }
    },
    /*
    watch: {
      getAllCases (cases) {
        // this.caseData = cases.find(cas => cas.id === parseInt(this.id))
        this.$store.dispatch('loadCaseForms', this.caseData)
      },
      id () {
        this.$store.dispatch('getCaseInvoices', this.id)
        this.$store.dispatch('loadCaseForms', this.caseData)
      }
    },
    */
    methods: {
      approveCase () {
        this.loading.approveCaseBtn = true
        this.$store.dispatch('approveCase', this.caseData.id).then(() => {
          this.$store.dispatch('getCaseInvoices', this.caseData.id)
          this.loading.approveCaseBtn = false
          this.caseData.status = 'approved'
        })
      },
      async loadData () {
        const response = await this.$axios.get(`${this.$store.getters.config.api_host}/api/cases/${this.id}`)
        if (response) {
          this.caseData = response.data.additional_data[0]
          const defaultPaymentData = {
            payment_method: null,
            payment_method_cc_datetime: null,
            payment_method_cc_remarks: null,
            payment_method_cash_collected_by: null,
            payment_method_cash_remarks: null,
            payment_method_cheque_collected_by: null,
            payment_method_cheque_remarks: null,
            payment_method_ibanking_datetime: null,
            payment_method_ibanking_remarks: null
          }
          this.caseData = Object.assign(this.caseData, defaultPaymentData)
          const paymentData = JSON.parse(response.data.additional_data[0].payment_info) || { payment_method: null }
          this.caseData = Object.assign(this.caseData, paymentData)
          this.formAnswer = this.caseData && this.caseData.answers && this.caseData.answers[0] && this.caseData.answers[0].answer ? JSON.parse(this.caseData.answers[0].answer) : null
        }
      },
      updatePaymentMethod (value) {
        this.caseData.payment_method = value
      },
      updatePaymentInfo (value) {
        this.caseData = Object.assign(this.caseData, value.payment_info)
      }
    },
    created () {
      if (this.$store.state.products.categories.length === 0) this.$store.dispatch('getProductsCategories')
      if (!this.$can('view', 'vendor') && this.$store.state.users.allUsers.length === 0) this.$store.dispatch('getAllUsers')
      if (!this.$can('view', 'vendor') && this.$store.state.clients.all.length === 0) this.$store.dispatch('getAllClients')
      if (!this.$can('view', 'vendor') && this.$store.state.plans.all.length === 0) this.$store.dispatch('getAllPlans')
      if (this.$store.state.products.all.length === 0 || this.$store.state.products.caskets.length === 0) this.$store.dispatch('getAllProducts')
      if (this.$store.state.services.all.length === 0) this.$store.dispatch('getAllServices')
      if (this.$store.state.users.caseManagers.length === 0) this.$store.dispatch('getCaseManagers')
      if (!this.caseData) this.loadData()
      // this.caseData = this.getAllCases.find(cas => cas.id === parseInt(this.id))
      // console.log('case data', this.caseData)
      if (this.goToCheckListsTab) {
        if (this.$can('view', 'cases-detail-checklist-tab')) {
          this.selectedTab1 = 'checklist-tab'
        } else if (this.$can('view', 'cases-detail-checklist-crew-tab')) {
          this.selectedTab1 = 'checklist-crew-tab'
        }
      } else if (this.goToInvoicesTab) {
        this.selectedTab2 = 'pdf-tab'
      }
    }
  }
</script>

<style scoped>
  h2 {
    text-transform: uppercase;
    font-weight: normal;
    border-bottom: 1px solid #eee;
    margin-bottom: 20px;
    padding-bottom: 10px;
    position: relative;
    font-size: 18px;
  }
  h2:after {
    content: '';
    display: block;
    width: 100%;
    height: 1px;
    background: #fff;
    position: absolute;
    bottom: -2px;
  }
</style>



// WEBPACK FOOTER //
// CasesDetail.vue?a1b5ba2e